// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202603311453/js/" + chunkId + "." + {"44":"704ac1f0","225":"bf56e913","481":"422bc053","486":"9a132395","770":"39184fa8"}[chunkId] + ".0.2064227850988556.chunk.js";
};